module.exports = __webpack_public_path__ + "static/img/solutionDetailIcon09.cb7449e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailIcon09.png
// module id = ydC5
// module chunks = 0